// Math detection patterns
export const mathPatterns = {
  latexInline: /\\\((.+?)\\\)/g,
  latexDisplay: /\\\[(.+?)\\\]/g,
  commands: /\\(?:frac|sqrt|sum|int|alpha|beta|gamma|theta|pi)/
};

export function hasMathContent(text: string): boolean {
  return Object.values(mathPatterns).some(pattern => pattern.test(text));
}

// Cache for loaded math extension
let mathExtensionCache: any = null;
let katexCssLoaded = false;

export async function loadMathExtension(): Promise<any> {
  if (mathExtensionCache) {
    return mathExtensionCache;
  }

  try {
    // Load KaTeX CSS if not already loaded
    if (!katexCssLoaded && typeof document !== "undefined") {
      const link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = "https://cdn.jsdelivr.net/npm/katex@0.16.10/dist/katex.min.css";
      link.integrity = "sha384-wcIxkf4k558AjM3Yz3BBFQUbk/zgIYC2R0QpeeYb+TwlBVMrlgLqwRjRtGZiK7ww";
      link.crossOrigin = "anonymous";
      document.head.appendChild(link);
      katexCssLoaded = true;
    }

    // Dynamically import the math extension
    const { default: MathExtension } = await import("@aarkue/tiptap-math-extension");

    // Create and cache the extension - using bracket delimiters to avoid conflicts with dollar amounts
    // This uses \(...\) for inline and \[...\] for block math
    mathExtensionCache = MathExtension.configure({
      delimiters: "bracket", // Uses \(...\) for inline, \[...\] for block
      katexOptions: {
        throwOnError: false,
        maxSize: 20, // Limit equation size
        trust: false // Disable dangerous features
      }
    });

    return mathExtensionCache;
  } catch (error) {
    console.error("Failed to load math extension:", error);
    throw error;
  }
}
